import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ScrollToTop } from '@/shared/components';
import HomePage from '@/features/Home/HomePage';
import HowItWorksPage from '@/features/HowItWorks';
import ResultsPage from '@/features/Results';
import PricingPage from '@/features/Pricing';
import FAQPage from '@/features/FAQ';
import ScheduleCallPage from '@/features/ScheduleCall';
import BookDemoPage from '@/features/BookDemo';
import InstantDemoPage from '@/features/InstantDemo';
import { PrivacyPage } from '@/features/Privacy';
import { TermsPage } from '@/features/Terms';
import { AgentsPage } from '@/features/Agents';
import { BrokeragesPage } from '@/features/Brokerages';
import {
  AccountLayout,
  AccountBillingPage,
  AccountDashboardPage,
  AccountPremiumLeadsPage,
  AccountHelpCenterPage,
  AccountLeadsPage,
  AccountClearancePage,
  AccountTeamPage,
  AccountTerritoryPage,
  AccountElLeadsPage,
  AccountElAccountsPage
} from '@/features/Account';
import NotFoundPage from '@/features/NotFound/NotFoundPage';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/brokerages" element={<BrokeragesPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/schedule-call" element={<ScheduleCallPage />} />
        <Route path="/demo" element={<BookDemoPage />} />
        <Route path="/instant-demo" element={<InstantDemoPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/el" element={<Navigate to="/account/el" replace />} />
        <Route path="/account" element={<AccountLayout />}>
          <Route index element={<AccountDashboardPage />} />
          <Route path="purchase-leads" element={<AccountPremiumLeadsPage />} />
          <Route path="help-center" element={<AccountHelpCenterPage />} />
          <Route
            path="premium-leads"
            element={<Navigate to="/account/purchase-leads" replace />}
          />
          <Route path="leads" element={<AccountLeadsPage />} />
          <Route path="clearance" element={<AccountClearancePage />} />
          <Route path="territory" element={<AccountTerritoryPage />} />
          <Route path="team" element={<AccountTeamPage />} />
          <Route path="billing" element={<AccountBillingPage />} />
          <Route path="el" element={<AccountElLeadsPage />} />
          <Route path="el-accounts" element={<AccountElAccountsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
